import { WHATSAPP_DEMO_STATUS_LOADING,WHATSAPP_DEMO_STATUS_SUCCESS,WHATSAPP_DEMO_STATUS_FAILED } from '../actions/whatsappDemo.action';
import { WhatsappDemoReducer } from '../models/whatsappDemo.interface';

const initialState: WhatsappDemoReducer = {
    whatsappDemoStatusData: [],
    whatsappDemoStatusLoading: true,
    whatsappDemoStatusError: false,
    whatsappDemoErrorMsg:''
}

const whatsappDemoReducer = (state: WhatsappDemoReducer = initialState, action: any): WhatsappDemoReducer => {

    switch (action.type) {
        case WHATSAPP_DEMO_STATUS_LOADING:
            return {
                ...state,
                whatsappDemoStatusLoading: true,
                whatsappDemoStatusError: false
            }
        case WHATSAPP_DEMO_STATUS_SUCCESS:
            return {
                ...state,
                whatsappDemoStatusLoading: false,
                whatsappDemoStatusError: false,
                whatsappDemoStatusData: action.payload.res.data[0].status
            }
        case WHATSAPP_DEMO_STATUS_FAILED:
            return {
                ...state,
                whatsappDemoStatusLoading: false,
                whatsappDemoStatusError: true,
                whatsappDemoErrorMsg:action.payload.error
            }
        default:
            return state;
    }
}

export default whatsappDemoReducer;